import React, { Component } from 'react';
 // Import your CSS file for styling

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate error
    return { hasError: true, errorMessage: error.toString() };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
                <link rel="stylesheet" href="assets/css/errorBoundary.css" />
        <div className="error-container">
          <div className="error-content">
            <h1>Oops! Something went wrong.</h1>
            <p>{this.state.errorMessage}</p>
            <p>Please try again later.</p>
          </div>
        </div>
        </div>
      );
    }

    // If no error, render children
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// src/ErrorBoundary.js